<div class="container">
  <div class="row align-items-start">
    <div class="col-sm-4">

      <div class="card" *ngIf="user">
        <h5 class="card-header">{{user.login}}</h5>
        <img src="{{user.avatar_url}}" alt="" class="card-img-top">
        <div class="card-body">
          <h5 class="card-title">{{user.name}}</h5>
          <p class="card-text">{{ user.bio }}</p>
          <ul class="list-group list-group-flush">
              <li class="list-group-item">Email: {{user.email || 'private'}}</li>
              <li class="list-group-item">Followers: {{ user.followers }}</li>
              <li class="list-group-item">Following: {{ user.following }}</li>
          </ul>

        </div>
      </div>

    </div>
    <div class="col-sm-8" *ngIf="!toogleTable">

      <table class="table">
        <thead>
          <tr>
            <th class="table-header" *ngFor="let item of headerTable" (click)="onSort(repos, item.type, item.order);toggleOrder(item);">{{item.name}} <fa-icon class="-{{item.type}}" [icon]="faSort"></fa-icon></th>
            <!-- <th>Name</th>
            <th>Linguagem</th>
            <th (click)="onSort(repos)">Stars</th>
            <th>Ações</th> -->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of repos">
            <td><a routerLink="/user/{{user.login}}/{{item.name}}" routerLinkActive="router-link-active">{{item.name}}</a></td>
            <td>{{item.language}}</td>
            <td>{{item.stargazers_count}}</td>
            <td>
              <a class="btn btn-success" href="{{item.html_url}}" target="_blank"><fa-icon [icon]="faExternalLinkAlt"></fa-icon> Github</a>
            </td>
          </tr>

        </tbody>
      </table>

    </div>
    <div class="col-sm-8 align-self-center" *ngIf="toogleTable">
      <h5>Não possui repositórios</h5>
    </div>
  </div>
</div>
